import React from 'react';
import { TextField } from '@mui/material';

/* Matches the size of the class_instance_exercises.target column on the backend */
export const CLASS_EXERCISE_TARGET_MAX_LENGTH = 4;

type ClassExerciseTargetFieldProps = {
    /* The target currently saved for the station */
    value?: string | null;
    /* Called with the trimmed text (empty to clear it) when the user leaves the field with a changed value */
    onSave: (target: string) => void;
};

export function ClassExerciseTargetField({ value, onSave }: ClassExerciseTargetFieldProps) {
    const [text, setText] = React.useState(value ?? '');

    // The saved value can change from outside, e.g. it is cleared when the exercise is changed
    React.useEffect(() => {
        setText(value ?? '');
    }, [value]);

    const handleSave = () => {
        const target = text.trim();
        setText(target);

        if (target !== (value ?? '')) {
            onSave(target);
        }
    };

    return (
        <TextField
            label="Target (optional)"
            placeholder="e.g. 500m, 1km, 250c"
            value={text}
            onChange={(event) => setText(event.target.value)}
            onBlur={handleSave}
            onKeyDown={(event) => {
                if (event.key === 'Enter') {
                    (event.target as HTMLInputElement).blur();
                }
            }}
            inputProps={{ maxLength: CLASS_EXERCISE_TARGET_MAX_LENGTH }}
            sx={{ width: 220, ml: 2 }}
        />
    );
}
